exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toggle___2JmPv {\n  display: flex;\n}\n\n.Toggle___2JmPv > span { /* targets .ToggleContent */\n  padding: 0;\n}\n\n.Badge___3Nnpi {\n  cursor: help;\n}\n", ""]);

// exports
exports.locals = {
	"Toggle": "Toggle___2JmPv",
	"Badge": "Badge___3Nnpi"
};